const TOKEN_KEY = 'jwt';

export function getToken() {
  const token = sessionStorage.getItem(TOKEN_KEY);
  return token ? `Bearer ${token}` : '';
}
export function removeToken() {
  sessionStorage.removeItem(TOKEN_KEY);
}

export function setToken(token: string) {
  sessionStorage.setItem(TOKEN_KEY, token);
}
